













































import { defineComponent, ref, watch, PropType } from '@vue/composition-api';
import { DataTableHeader } from 'vuetify';
import { SearchTextsResultRow } from '@oare/types';

export default defineComponent({
  props: {
    searchResults: {
      type: Array as PropType<SearchTextsResultRow[]>,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    totalSearchResults: {
      type: Number,
      required: true,
    },
    searchTotalLoading: {
      type: Boolean,
      default: false,
    },
    page: {
      type: Number,
      default: 1,
    },
    rows: {
      type: Number,
      default: 10,
    },
    headers: {
      type: Array as PropType<DataTableHeader[]>,
      required: true,
    },
  },
  setup(props, { emit }) {
    const searchOptions = ref({
      page: props.page,
      itemsPerPage: props.rows,
    });

    watch(
      () => props.page,
      () => (searchOptions.value.page = props.page)
    );
    watch(
      () => props.rows,
      () => (searchOptions.value.itemsPerPage = props.rows)
    );

    watch(
      () => searchOptions.value.page,
      () => {
        emit('update:page', searchOptions.value.page);
      },
      { immediate: false }
    );
    watch(
      () => searchOptions.value.itemsPerPage,
      () => {
        emit('update:rows', searchOptions.value.itemsPerPage);
      },
      { immediate: false }
    );

    return {
      searchOptions,
    };
  },
});
